const translations = {
  en: {
    language: {
      toggleShort: 'ES',
      toggleLabel: 'Switch to Spanish',
    },
    nav: {
      works: 'Works',
      about: 'About',
      contact: 'Contact',
      openMenu: 'Open navigation menu',
    },
    main: {
      headline: {
        line1: 'Hey there. I am David',
        line2: 'I am a software Developer',
      },
      description: 'Hello! My name is David, and I am a Full-Stack software developer with a passion for leveraging software engineering to enhance web-based tools.',
      cta: "Let's collaborate",
      social: {
        intro: 'Find me on',
        and: 'and',
        resumePrefix: 'Download my',
        resumeLink: 'Resume',
      },
    },
    menu: {
      title: 'Navigation',
      subtitle: 'Explore my portfolio',
      closeAria: 'Close menu',
      ctaLabel: "Let's build something",
      ready: 'Ready to collaborate?',
    },
    works: {
      title: 'Projects',
      subtitle: "Swipe or drag to see some of the projects I've worked on.",
      prev: 'Show previous project',
      next: 'Show next project',
    },
    about: {
      title: 'About me',
      paragraph: "I'm a front-end and back-end developer who enjoys collaborating with design teams to accurately translate their ideas. Using modern technologies to bring creativity to life is my passion.",
      skills: {
        languages: 'Languages',
        frameworks: 'Frameworks',
        skills: 'Skills',
      },
    },
    contact: {
      title: 'Contact me',
      subtitle: "Don't be shy!",
      description: 'If you have any questions or want to work with me, please contact me.',
      labels: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
      },
      placeholders: {
        name: 'Your name',
        email: 'Your email',
        message: 'Your message',
      },
      submit: 'Send message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Failed to send message. Please try again later.',
      validation: {
        nameRequired: 'Let me know who I am talking to.',
        emailRequired: 'I need your email address to get back to you.',
        emailInvalid: 'Double-check the email format (e.g. name@domain.com).',
        messageRequired: 'Share a few details about your idea or question.',
      },
    },
    popup: {
      dialogLabel: 'Project details for',
      visit: 'Visit project',
      code: 'View code',
      closeAria: 'Close project details',
    },
  },
  es: {
    language: {
      toggleShort: 'EN',
      toggleLabel: 'Cambiar a inglés',
    },
    nav: {
      works: 'Proyectos',
      about: 'Sobre mí',
      contact: 'Contacto',
      openMenu: 'Abrir menú de navegación',
    },
    main: {
      headline: {
        line1: 'Hola. Soy David',
        line2: 'Soy desarrollador de software',
      },
      description: '¡Hola! Mi nombre es David y soy desarrollador Full-Stack con pasión por aprovechar la ingeniería de software para potenciar herramientas web.',
      cta: 'Colaboremos',
      social: {
        intro: 'Encuéntrame en',
        and: 'y',
        resumePrefix: 'Descarga mi',
        resumeLink: 'Currículum',
      },
    },
    menu: {
      title: 'Navegación',
      subtitle: 'Explora mi portafolio',
      closeAria: 'Cerrar menú',
      ctaLabel: 'Construyamos algo',
      ready: '¿Listo para colaborar?',
    },
    works: {
      title: 'Proyectos',
      subtitle: 'Desliza para descubrir algunos de los proyectos en los que he trabajado.',
      prev: 'Ver proyecto anterior',
      next: 'Ver siguiente proyecto',
    },
    about: {
      title: 'Sobre mí',
      paragraph: 'Soy un desarrollador full-stack al que le encanta colaborar con equipos de diseño para llevar sus ideas a productos funcionales. Usar tecnología moderna para convertir la creatividad en realidad es mi pasión.',
      skills: {
        languages: 'Lenguajes',
        frameworks: 'Frameworks',
        skills: 'Habilidades',
      },
    },
    contact: {
      title: 'Contáctame',
      subtitle: '¡No seas tímido!',
      description: 'Si tienes alguna pregunta o quieres trabajar conmigo, no dudes en escribirme.',
      labels: {
        name: 'Nombre',
        email: 'Correo',
        message: 'Mensaje',
      },
      placeholders: {
        name: 'Tu nombre',
        email: 'Tu correo',
        message: 'Tu mensaje',
      },
      submit: 'Enviar mensaje',
      sending: 'Enviando...',
      success: '¡Mensaje enviado con éxito!',
      error: 'No se pudo enviar el mensaje. Inténtalo de nuevo más tarde.',
      validation: {
        nameRequired: 'Cuéntame cómo debo dirigirme a ti.',
        emailRequired: 'Necesito tu correo electrónico para responderte.',
        emailInvalid: 'Revisa que el correo tenga un formato válido (ej. nombre@dominio.com).',
        messageRequired: 'Comparte algunos detalles sobre tu idea o consulta.',
      },
    },
    popup: {
      dialogLabel: 'Detalles del proyecto para',
      visit: 'Ver proyecto',
      code: 'Ver código',
      closeAria: 'Cerrar detalles del proyecto',
    },
  },
};

export default translations;
